module.exports = __webpack_public_path__ + "img/adone.cf68309a.svg";